import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SolutionsAppService } from 'src/app/services/solutions-app.service';
import { SubscriptionAppService } from 'src/app/services/subscription-app.service';
import { SolutionExecutorFormComponent } from 'src/app/modules/sales-dna/components/solution-executor-form/solution-executor-form.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { AddUserInSubscribedSolnComponent } from '../add-user-in-subscribed-soln/add-user-in-subscribed-soln.component';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';

@Component({
  selector: 'app-cus-solutions',
  template: `
    <div class="cs-page">
      <div class="pagehead">
        <h1>My solutions</h1>
        <p>Run your subscribed solutions and manage who can access them.</p>
      </div>

      <div class="tabs">
        <span
          class="tab"
          [class.active]="activeTab === 'current'"
          (click)="activeTab = 'current'"
          >Current <span class="cnt">{{ availableSubscriptions?.length || 0 }}</span></span
        >
        <span
          class="tab"
          [class.active]="activeTab === 'past'"
          (click)="activeTab = 'past'"
          >Past <span class="cnt">{{ pastSubscription?.length || 0 }}</span></span
        >
      </div>

      <!-- Current subscriptions -->
      <div class="sub-list" *ngIf="activeTab === 'current'">
        <div class="empty" *ngIf="!availableSubscriptions?.length">
          No active subscriptions yet. Browse the marketplace to subscribe to a solution.
        </div>

        <div class="sub-card" *ngFor="let sub of availableSubscriptions">
          <div class="sub-head">
            <div class="sub-ico">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
                   stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" />
              </svg>
            </div>
            <div class="sub-mid">
              <div class="sub-nm">
                <span
                  [matTooltip]="'Complete the configuration form to run this solution'"
                  (click)="previewForm(sub)"
                  >{{ sub['solution_name'] | textpretty | titlecase }}</span
                >
                <span class="vchip" *ngIf="sub['version_name']">{{ sub['version_name'] }}</span>
              </div>
              <div class="sub-meta">{{ subMeta(sub) }}</div>
            </div>
            <div class="sub-actions">
              <button class="btn-ghost" (click)="addUsers(sub)">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                     stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="9" cy="8" r="3" /><path d="M2 21c0-3.5 3-6 7-6s7 2.5 7 6" />
                  <path d="M17 8a3 3 0 0 1 0 6M22 21c0-2.5-1.3-4.4-3.5-5.3" />
                </svg>
                Manage users
              </button>
              <button class="btn-primary" (click)="previewForm(sub)">
                <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none">
                  <path d="M8 5v14l11-7z" />
                </svg>
                Run
              </button>
              <span
                class="expander"
                [class.open]="expanded[sub['subscription_id']]"
                matTooltip="Show projects"
                (click)="toggle(sub)"
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
                     stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </span>
            </div>
          </div>

          <div class="proj-wrap" *ngIf="expanded[sub['subscription_id']]">
            <div class="proj-lbl">Projects in this solution</div>
            <div
              class="proj-empty"
              *ngIf="!availableProjectBySubscriptionId[sub['subscription_id']]?.length"
            >
              No projects in this solution.
            </div>
            <div
              class="proj-row"
              *ngFor="let project of availableProjectBySubscriptionId[sub['subscription_id']]"
            >
              <span class="proj-ico">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                     stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 7h10M4 12h16M4 17h7" />
                </svg>
              </span>
              <span class="proj-nm" [matTooltip]="project['project_name']">{{
                project['project_name'] | namingsize : 50
              }}</span>
              <button
                class="btn-ghost"
                (click)="runProject(sub, project['project_id'], project['project_name'])"
              >
                <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" stroke="none">
                  <path d="M8 5v14l11-7z" />
                </svg>
                Run
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Past subscriptions -->
      <div class="sub-list" *ngIf="activeTab === 'past'">
        <div class="empty" *ngIf="!pastSubscription?.length">No past subscriptions.</div>
        <div class="past-card" *ngFor="let sub of pastSubscription">
          <div class="past-ico">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                 stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" />
            </svg>
          </div>
          <div class="past-mid">
            <div class="past-nm">{{ sub['solution_name'] | textpretty | titlecase }}</div>
            <div class="past-meta">
              Expired {{ sub['expires_on_dtm'] | date : 'dd MMM yyyy' }}
            </div>
          </div>
          <span class="exp-badge">Expired</span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./cus-solutions.component.scss'],
})
export class CusSolutionsComponent implements OnInit {
  componentCheck: boolean = false;
  availableSubscriptions: any;
  pastSubscription: any;
  formData: any;
  availableProjectBySubscriptionId: any = {};
  activeTab: 'current' | 'past' = 'current';
  expanded: { [subscriptionId: string]: boolean } = {};

  constructor(
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private subscriptionServices: SubscriptionAppService,
    private solutionServices: SolutionsAppService,
    private formDialogs: MatDialog,
    private detectChange: ChangeDetectorRef,
    private snackBar: SharedFeaturesService
  ) {}

  ngOnInit(): void {
    if (this.route.component === CusSolutionsComponent) {
      this.componentCheck = false;
    } else {
      this.componentCheck = true;
    }
    this.fetchSubscription();
  }

  toggle(sub: any) {
    const id = sub?.subscription_id;
    this.expanded[id] = !this.expanded[id];
  }

  subMeta(sub: any): string {
    const parts: string[] = [];
    if (sub?.started_on_dtm) {
      parts.push(
        'Subscribed ' + this.datePipe.transform(sub.started_on_dtm, 'dd MMM yyyy')
      );
    }
    if (sub?.no_of_users) {
      parts.push(`${sub.no_of_users} user${sub.no_of_users === 1 ? '' : 's'}`);
    }
    if (sub?.expires_on_dtm) {
      parts.push(
        'renews ' + this.datePipe.transform(sub.expires_on_dtm, 'dd MMM yyyy')
      );
    }
    return parts.join(' · ');
  }

  fetchSubscription() {
    this.subscriptionServices.getSubscribedSolutions().subscribe({
      next: (response: any) => {
        this.availableSubscriptions = response['msg'];
        (this.availableSubscriptions || []).forEach((s: any) => {
          this.expanded[s.subscription_id] = true;
        });
        this.getAvailableProjectsForEachSubscription(
          this.availableSubscriptions
        );
        this.fetchPastSubscription();
      },
    });
  }

  fetchPastSubscription() {
    this.subscriptionServices.getUnSubscribedSolutions().subscribe({
      next: (response: any) => {
        this.pastSubscription = response['msg'];
        this.pastSubscription = this.pastSubscription.filter(
          (item2: any) =>
            !this.availableSubscriptions.some(
              (item1: any) => item1.solution_id === item2.solution_id
            )
        );
      },
    });
  }

  addUsers(solution: any) {
    const formDialogRef = this.formDialogs.open(
      AddUserInSubscribedSolnComponent,
      {
        data: solution,
        width: '600px',
        maxWidth: '92vw',
        panelClass: 'manage-users-dialog',
        disableClose: false,
      }
    );
    formDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.debug('Submit');
      }
      this.detectChange.detectChanges();
    });
  }

  previewForm(subscriptionDetails: any) {
    this.solutionServices
      .getForm(
        { solution_id: subscriptionDetails['solution_id'] },
        { version_id: subscriptionDetails['version_id'] }
      )
      .subscribe({
        next: (response: any) => {
          if (response.length == 0) {
            this.formData = undefined;
          } else {
            const temp = {
              subscriptionDetails: subscriptionDetails,
              formData: response[0],
              preview: false,
            };
            this.formData = temp;
          }
          const formDialogRef = this.formDialogs.open(
            SolutionExecutorFormComponent,
            {
              data: this.formData,
              disableClose: false,
            }
          );
          formDialogRef.afterClosed().subscribe((result) => {
            if (result) {
              console.debug('Submit');
            }
            this.detectChange.detectChanges();
          });
        },
      });
  }

  runVersion(solutionId: string, versionId: string) {
    let temp = {
      project_ids: [],
      pipeline_ids: [],
      node_ids: [],
      tags: [],
    };
    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(solutionId, versionId, temp)
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `Run queued${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error: any) => {
          console.error(
            'an error occurred while running solution',
            JSON.stringify(error)
          );
          this.snackBar.openSnackBar(
            'Unable to run solution',
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  getAvailableProjectsForEachSubscription(subscriptionDetails: any) {
    subscriptionDetails.forEach((element: any) => {
      this.solutionServices
        .getAvailableProjects(element, element, '')
        .subscribe({
          next: (response: any) => {
            this.availableProjectBySubscriptionId[element?.subscription_id] =
              response;
          },
          error: (error: any) => {
            console.error('an error occurred', JSON.stringify(error));
          },
        });
    });
  }

  runProject(subscription: any, projectId: string, projectName: string) {
    let data = {
      project_ids: [projectId],
      pipeline_ids: [],
      node_ids: [],
      tags: [],
    };
    this.snackBar.openSnackBar(
      `Starting "${projectName}"…`,
      'Close',
      'progress-snackbar'
    );
    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        subscription?.solution_id,
        subscription?.version_id,
        data
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `"${projectName}" started${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          this.snackBar.openSnackBar(
            'Unable to run Project',
            'Close',
            'error-snackbar'
          );
        },
      });
  }
}
